// place the index of the items between the locale mapping
export const featuredItems = [
  {
    href: '/blog/fast-efficient-and-accurate-web-accessibility-automation-tool',
    category: 'accessibility',
    date: new Date(Date.UTC(2023, 1, 4, 3, 0, 0)),
    backgroundImage: `bg-[url('/img/webflow/a11ywatch-dashboard.webp')]`,
    index: 2,
  },
  {
    href: '/blog/web-accessibility-monitoring',
    category: 'api',
    date: new Date(Date.UTC(2022, 3, 21, 3, 0, 0)),
    backgroundImage: `bg-[url('/img/webflow/a11ywatch-playground.webp')]`,
    index: 1,
  },

  {
    href: '/blog/next-js-to-astro',
    category: 'engineering',
    date: new Date(Date.UTC(2022, 5, 22, 3, 0, 0)),
    backgroundImage: `bg-[url('/img/webflow/astro-compare.webp')]`,
    index: 0,
  },
  {
    href: '/blog/version-your-proto-definitions-for-stability',
    category: 'engineering',
    date: new Date(Date.UTC(2022, 5, 23, 3, 0, 0)),
    backgroundImage: `bg-[url('/img/webflow/grpc-logo.webp')]`,
    index: 3,
  },
  {
    href: '/blog/create-blog-nextjs',
    category: 'api',
    date: new Date(Date.UTC(2022, 0, 3, 3, 0, 0)),
    backgroundImage: `bg-[url('/img/webflow/air-ballons.webp')]`,
    index: 4,
  },
  {
    href: '/blog/public-release',
    category: 'accessibility',
    date: new Date(Date.UTC(2020, 7, 20, 3, 0, 0)),
    backgroundImage: `bg-[url('/img/webflow/ca-bridge.webp')]`,
    index: 5,
  },
  {
    href: '/blog/web-accessibility-api',
    category: 'api',
    date: new Date(Date.UTC(2020, 5, 19, 3, 0, 0)),
    backgroundImage: `bg-[url('/img/webflow/lake-orange.webp')]`,
    index: 6,
  },
  {
    href: '/blog/editable-custom-scripts',
    category: 'wcag',
    date: new Date(Date.UTC(2020, 3, 22, 3, 0, 0)),
    backgroundImage: `bg-[url('/img/webflow/cloud-trains.webp')]`,
    index: 7,
  },
  {
    href: '/blog/web-accessibility-checker',
    category: 'accessibility',
    date: new Date(Date.UTC(2020, 4, 17, 3, 0, 0)),
    backgroundImage: `bg-[url('/img/webflow/waterfall-rainbow.webp')]`,
    index: 8,
  },
]
